import React, { Component } from 'react';
import jQuery from 'jquery';
import FetchCall from '../../../../API/FetchCall';
import { getCuratedCampListV2, deleteSummerCamp } from '../../../../API/FetchCall';
const $ = require('jquery')
//$.DataTable = require('datatables.net');
class CuratedCamps extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        this.state = {
            logged: localStorage.getItem("authentication"),
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            write_permission: false,
            camplist: []

        }
        this.getCuratedCampList();
    }

    componentDidMount() {

        var THIS = this;

    }

    getCuratedCampList = () => {
        console.log(this.state.auth_data);
        const { login_id, role } = this.state.auth_data;
        let ins = JSON.stringify({
            vendor_id: login_id
        });
        getCuratedCampListV2(ins).then((res) => {
            if (res.status == 1) {
                this.setState({
                    write_permission: res.write_permission,
                    camplist: res.data,
                });
                this.datatabledata(res.data);
            } else {
                this.setState({
                    camplist: [],
                });
            }
        });
    }

    datatabledata(data) {


        this.setState({
            dataSet: data
        })
        this.el = $(this.el)
        this.el.DataTable(
            {
                data: this.state.dataSet,
                orderable: false,
                columns: [
                    { data: 's_no' },
                    { data: 'camp_name' },
                    { data: 'status' },
                    { data: 'action' },
                ]

            }
        )
    }

    deleteScl = () => {
        let ins = JSON.stringify({
            id: this.state.delete_id
        });
        deleteSummerCamp(ins).then((res) => {
            let toastr = '';
            if (res.status === 1) {
                toastr = window.toastr.success;
                toastr('success', 'Deleted successfully', {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            } else {
                toastr = res.message; //warning
                toastr('Error', toastr, {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
            }
        });
    }

    componentDidUpdate() {
        //window.jQuery('.selectpicker').selectpicker('refresh');
    }

    render() {
        return (
            <React.Fragment>
                <div class="box-shadow-custom">
                    {/* <h1>BeWise Curated Camps List</h1> */}
                    <small>Note: Applicable for only pre agreed customers only. 
                        <a href='mailto:anand.k@bewise.in'>Contact us</a> for enquires</small>
                    <div className="row">
                        <div className="col-md-12 col-xs-12 text-right">


                            <div className="pull-right">
                                <div className="dropdown menu-item">
                                    <button className="btn btn-green dropdown-toggle btn-arrow btn-circle" data-toggle="dropdown" aria-expanded="false">
                                        <i className="fa fa-plus-circle" aria-hidden="true"></i> Add
                                        <span className="caret"></span></button>
                                    <ul className="dropdown-menu align-right">
                                        <li><a href="/requestforcurated">Create Request</a></li>

                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="main-content col-md-12 col-xs-12">
                            <div className="box-shadow-custom">
                                <div className="table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                                    <table className="table table-custom-design table-striped dataTable" ref={el => this.el = el}>
                                        <thead>
                                            <tr role="row">
                                                <th className="tabledata">S.No</th>
                                                <th className="tabledata">Camp Name</th>
                                                <th className="tabledata">Approval Status</th>
                                                <th className="tabledata">Action</th>
                                            </tr>
                                        </thead>
                                        {/* <tbody>
            {this.renderList()}
        </tbody> */}

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" role="dialog" tabindex="-1" id="checkout-modal">
                        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Confirmation</h5>
                                </div>
                                <div class="modal-body">
                                    <p>Are you sure want to remove this Camp?</p>
                                    <input type="hidden" id="cart_id" />
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                                    <button type="button" class="btn btn-success" data-dismiss="modal" aria-label="Close" onClick={() => { this.deleteScl() }}>Remove</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


export default CuratedCamps;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/branch/curatedcamps.jsx